import { Pipe, PipeTransform } from '@angular/core';
import { Assignee } from '@workspaces/models/task';

@Pipe({
  name: 'shortId',
  standalone: true
})
export class ShortIdPipe implements PipeTransform {
  private cache = new Map<string, string>();

  transform(uuid: string | Assignee | null | undefined): string {
    const name = (uuid as Assignee)?.name ?? uuid;
    if (!name) {
      return '#N/A';
    }

    // Handle emails
    if (name.includes('@')) {
      return name;
    }

    if (this.cache.has(name)) {
      return this.cache.get(name)!;
    }

    const hex = name.replace(/-/g, '');
    const slice = hex.substring(8, 16);
    const baseNumber = parseInt(slice, 16);
    const uniquePart = (baseNumber & 0xffff).toString(16).toUpperCase().padStart(4, '0');
    const result = `#Unknown-${uniquePart}`;

    this.cache.set(name, result);
    return result;
  }
}
